// @flow
import TrendModel from "src/models/TrendModel";
import { entityReducer } from "src/utils/reducerUtils";

export const trends = entityReducer({ name: "trends", Model: TrendModel });
